import React, { useState } from "react";
import "./styles.css";

import { Row, Col, Button } from "antd";
import { IMAGE_BASE_URL } from "../../../../services/api";
import LocalizationContext from "../../../../localization/LocalizationContext";
import { Link } from "react-router-dom";
import TagsDisplay from "../../tagsdisplay/TagsDisplay";

import { formatDate } from "../../../helper/formatDate";

export default function HomeSection1(props) {
  const { t, i18n } = React.useContext(LocalizationContext);

  const [showHoverEffect, setShowHoverEffect] = useState(false)

  const onHoverStyleText = {
    textDecoration: "underline"
  }
  const onHoverStyleImage = {
    opacity: 0.8
  }
  const onMouseHoverHeadingOrImage = () => {
    setShowHoverEffect(true)
  }
  const onMouseRemoveHeadingOrImage = () => {
    setShowHoverEffect(false)
  }

  const { isLoading, data, error } = props.queryData;
  return (
    <div className="homesection1__container">
      {isLoading && <p></p>}
      {data && data.length >= 1 && (
        <Row className="homesection1__content-row">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}
          >
            <div className="homesection1__image">
              <Link to={`/program/${data[0].id}`}>
                {data[0].mainImg && (
                  <img src={`${IMAGE_BASE_URL}${data[0].mainImg.url}`}
                    style={showHoverEffect ? { ...onHoverStyleImage } : null}
                    onMouseOver={onMouseHoverHeadingOrImage}
                    onMouseOut={onMouseRemoveHeadingOrImage}
                  />
                )}
              </Link>
            </div>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 3 }}
            xl={{ span: 3 }}
            xxl={{ span: 3 }}
          ></Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 9 }}
            xl={{ span: 9 }}
            xxl={{ span: 9 }}
          >
            <div className="homesection1__text">
              <div className="homesection1__text-top">
                <p className="homesection1__text-line1">
                  {formatDate(data[0].dateStart)} -{" "}
                  {formatDate(data[0].dateEnd)}
                </p>
                <Link to={`/program/${data[0].id}`}>
                  <p className="homesection1__text-line2 fs-2-5em lh-1-2em"
                    style={showHoverEffect ? { ...onHoverStyleText } : null}
                    onMouseOver={onMouseHoverHeadingOrImage}
                    onMouseOut={onMouseRemoveHeadingOrImage}
                  >
                    {data[0].artist && <span>{`${data[0].artist.name}`}</span>}{" "}
                  </p>
                  <p className="homesection1__text-line2 text-fabric-serif-italic fs-2-5em lh-1-2em"
                    style={showHoverEffect ? { ...onHoverStyleText } : null}
                    onMouseOver={onMouseHoverHeadingOrImage}
                    onMouseOut={onMouseRemoveHeadingOrImage}
                  >
                    {`${data[0].title}`}
                  </p>
                </Link>
              </div>
              <div className="homesection1__text-bottom">
                <p className="homesection1__text-description fs-1-2em lh-1-4em">
                  {data[0].shortDescription && <>{`${data[0].shortDescription} (...)`}</>}
                </p>
                <TagsDisplay tagList={data[0].tags} />
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}
